module.exports = __webpack_public_path__ + "img/move.ac62e80b.webp";